module.exports = __webpack_public_path__ + "img/powerfuleasy.71c634e3.png";